export const mergeCallbacks = <T extends unknown[]>(...callbacks: (((...args: T) => void) | undefined)[]): ((...args: T) => void) => {
  return (...args) => {
    callbacks.forEach((func) => func?.(...args));
  };
};
